import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import AddLessonToPrivateLibraryModal from 'views/my_library/modals/add_lesson_to_private_library_folder'
import myLibraryAddLessonToPrivateLibrary from 'redux/selectors/my_library/my_library_add_lesson_to_private_library'
import localize from 'helpers/translator/localize'
import userLibraryTypes from 'helpers/enums/userLibraryTypes'

class AddLessonToPrivateLibraryContainer extends PureComponent {
	// todo: for the navigation we should dispatch the action to get more folders -> and change the current folderUID?

	handleAddSelected = folderId => {
		this.props.actions.handleAddSelected(folderId, this.props.lesson, this.props.libraryType)
	}

	handleFolderIdUpdated = folderId => {
		this.props.actions.handleFolderIdUpdated(folderId, this.props.lesson, this.props.libraryType)
	}

	titles = {
		[userLibraryTypes.SCHOOL_LIBRARY]: localize('private_library_title_schoolLibrary_2'),
		[userLibraryTypes.DISTRICT_LIBRARY]: localize('private_library_title_districtLibrary_2'),
	}

	libraryTypes = {
		[userLibraryTypes.SCHOOL_LIBRARY]: localize('private_library_title_schoolLibrary'),
		[userLibraryTypes.DISTRICT_LIBRARY]: localize('private_library_title_districtLibrary'),
	}

	getCurrentFolderName = () => this.props.parentFolderId ?
		this.props.currentFolderName : this.libraryTypes[this.props.libraryType]

	render() {
		return (
			<AddLessonToPrivateLibraryModal
				title={this.titles[this.props.libraryType]}
				folders={this.props.folders}
				closeSelected={this.props.actions.handleModalClosed}
				handleAddLesson={this.handleAddSelected}
				handleFolderIdUpdated={this.handleFolderIdUpdated}
				parentFolderId={this.props.parentFolderId}
				currentFolderName={this.getCurrentFolderName()}
			/>
		)
	}
}

function mapStateToProps(state) {
	return myLibraryAddLessonToPrivateLibrary(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		handleModalClosed: myLibraryActions.addLessonToPrivateLibraryModalCloseSelected,
		handleAddSelected: myLibraryActions.addLessonToPrivateLibraryModalAddSelected,
		handleFolderIdUpdated: myLibraryActions.addLessonToPrivateLibraryModalFolderIdUpdated,
	}, dispatch)
}

AddLessonToPrivateLibraryContainer.propTypes = {
	folders: PropTypes.array,
	actions: PropTypes.shape({
		handleModalClosed: PropTypes.func.isRequired,
		handleAddSelected: PropTypes.func.isRequired,
		handleFolderIdUpdated: PropTypes.func.isRequired,
	}),
	lesson: PropTypes.object.isRequired,
	libraryType: PropTypes.string.isRequired,
	parentFolderId: PropTypes.string,
	currentFolderName: PropTypes.string,
}

AddLessonToPrivateLibraryContainer.defaultProps = {
	folders: [],
}

export default connect(mapStateToProps, mapDispatchToProps)(AddLessonToPrivateLibraryContainer)
